<template>
	<v-select :label="$t('ShoppingCart.Select_an_invoice_address')" :items="invoiceAddressList"
		:value="invoiceAddressId" @change="setInvoiceAddressId" item-value="addressId" outlined  hide-details>
		<template #selection="{ item }">
			<v-row align="center" class="ma-0">
				<v-col cols="6">
					<div>{{ item.organisationName }}</div>
					<div class="text-caption">{{ item.attentionTo }}</div>
				</v-col>
				<v-col cols="6" class="text-right">
					<div>{{ item.streetAddress1 }}</div>
					<div v-if="item.streetAddress2">{{ item.streetAddress2 }}</div>
					<div>{{ item.countryCode }}&nbsp;{{ item.zipCode }}&nbsp;{{ item.city }}</div>
				</v-col>
			</v-row>
		</template>
		<template #item="{ item }">
			<v-row>
				<v-col cols="6">
					<div>{{ item.organisationName }}</div>
					<div class="text-caption">{{ item.attentionTo }}</div>
				</v-col>
				<v-col cols="6">
					<div>{{ item.streetAddress1 }}</div>
					<div v-if="item.streetAddress2">{{ item.streetAddress2 }}</div>
					<div>{{ item.countryCode }}&nbsp;{{ item.zipCode }}&nbsp;{{ item.city }}</div>
				</v-col>
			</v-row>
		</template>
	</v-select>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
	name: "InvoiceAddressPicker",
	components: {},
	computed: {
		...mapGetters({
			invoiceAddressList: "shoppingCart/invoiceAddressList",
			invoiceAddressId: "shoppingCart/invoiceAddressId",
		}),
	},
	methods: {
		...mapMutations({
			setInvoiceAddressId: "shoppingCart/setInvoiceAddressId",
		}),
	},
};
</script>

